<template>
  <div class="page" :class="{ page_fill: videoConf.fullScreen }">
    <div
        id="container"
        @touchstart="handleTouchStart"
        @touchmove="handleTouchMove"
        @touchend="handleTouchEnd"
        @touchcancel="handleTouchEnd"
    ></div>

    <div class="loading" v-if="videoState != 2">
      <img src="../assets/image/loading.png" alt="" />
      <p>正在加载中…</p>
    </div>

    <img
        src="../assets/image/player.png"
        v-if="isH5 && isPlayer"
        @click="tapPlayer"
        class="play-1125"
        alt=""
    />

    <div
        :class="{ ptz: true, ptz_fill: videoConf.fullScreen }"
        @touchstart="touchstartClick"
        @touchend="touchEnd"
        ref="ptz"
        :style="{ display: videoConf.showPzt ? 'block' : 'none' }"
    >
      <img
          class="translucent"
          src="../assets/image/translucent.png"
          draggable="false"
          alt=""
      />
      <img
          v-if="!videoConf.fullScreen"
          class="up"
          :style="{ display: moveDirection === '1' ? 'block' : 'none' }"
          src="../assets/image/up.png"
          draggable="false"
          alt=""
      />
      <img
          v-else
          class="up"
          :style="{ display: moveDirection === '3' ? 'block' : 'none' }"
          src="../assets/image/up.png"
          draggable="false"
          alt=""
      />
      <img
          v-if="!videoConf.fullScreen"
          class="down"
          :style="{ display: moveDirection === '2' ? 'block' : 'none' }"
          src="../assets/image/down.png"
          draggable="false"
          alt=""
      />
      <img
          v-else
          class="down"
          :style="{ display: moveDirection === '4' ? 'block' : 'none' }"
          src="../assets/image/down.png"
          draggable="false"
          alt=""
      />
      <img
          v-if="!videoConf.fullScreen"
          class="right"
          :style="{ display: moveDirection === '4' ? 'block' : 'none' }"
          src="../assets/image/right.png"
          draggable="false"
          alt=""
      />
      <img
          v-else
          class="right"
          :style="{ display: moveDirection === '1' ? 'block' : 'none' }"
          src="../assets/image/right.png"
          draggable="false"
          alt=""
      />
      <img
          v-if="!videoConf.fullScreen"
          class="left"
          :style="{ display: moveDirection === '3' ? 'block' : 'none' }"
          src="../assets/image/left.png"
          draggable="false"
          alt=""
      />
      <img
          v-else
          class="left"
          :style="{ display: moveDirection === '2' ? 'block' : 'none' }"
          src="../assets/image/left.png"
          draggable="false"
          alt=""
      />
    </div>

    <img
        src="@/assets/image/speak.png"
        class="speak_fill"
        :style="{ display: videoConf.fullScreen ? 'block' : 'none' }"
    />

    <div
        class="sensor-list"
        v-if="sensorList.length > 0"
        ref="sensorListRef"
        @scroll="handleListScroll"
    >
      <div
          class="sensor-item"
          v-for="item in sensorList"
          :key="item.itemsId"
      >
        <div class="sensor-label">{{ item.deviceMac }}</div>
        <div class="sensor-temp" :class="getTempClass(item.temperatureStatus)">
          {{ item.temperature > 0 ? item.temperature : 0 }}℃
        </div>
        <div class="sensor-step">活动量：{{ item.stepCountSum }}</div>
        <div class="sensor-status">
          <div class="status-item"
               @click="item.expTimeStatus === 0 ? handleLightClick(item) : null"
               :class="{ 'clickable-item': item.expTimeStatus === 0 }">
            <button
                v-if="item.expTimeStatus === 0"
                class="status-btn online"
            >
              {{ isPolling && isPollingId===item.itemsId? '查找中...' : '查找' }}
            </button>
            <div v-else class="status-text offline">离线</div>
          </div>

          <div class="status-item">
            <button
                class="status-btn online"
                @click.stop="handleDeviceHistory(item)"
            >
              查看历史
            </button>
          </div>
        </div>
      </div>
      <div class="load-tips" v-if="isLoading">加载中...</div>
    </div>
    <!-- 投喂组件 -->
    <device-feed-control
        class="feed-control-wrapper"
        v-if="feeder  && feeder.id"
        :item="feeder"
    />
    <!-- 灌溉组件 -->
    <irrigation
        class="feed-control-wrapper"
        v-else-if="irrigation  && irrigation.id"
        :item="irrigation"
    />
    <div
        class="operation fixed-bottom"
        :class="{ operation_fill: videoConf.fullScreen }"
    >
      <img
          :src="definitionImage"
          @click="hd"
          :style="{ display: controls.includes('hd') ? 'block' : 'none' }"
          class="hd"
      />
      <div class="huif cute" @click="cute">回放</div>
      <img
          src="../assets/image/speak.png"
          @click="speak"
          :style="{ display: controls.includes('speak') ? 'block' : 'none' }"
          class="speak"
          v-if="!videoConf.audio"
      />
      <img
          v-else
          src="../assets/image/speaking.png"
          @click="speak"
          :style="{ display: controls.includes('speak') ? 'block' : 'none' }"
          class="speak"
      />
      <img
          src="../assets/image/Mute.png"
          @click="Mute"
          :style="{ display: controls.includes('Mute') ? 'block' : 'none' }"
          class="Mute"
          v-if="!videoConf.mute"
      />
      <img
          v-else
          src="../assets/image/Mute1.png"
          @click="Mute"
          :style="{ display: controls.includes('Mute') ? 'block' : 'none' }"
          class="Mute"
      />
      <img
          src="../assets/image/ptzclose.png"
          @click="ptzclose"
          :style="{ display: controls.includes('ptzclose') ? 'block' : 'none' }"
          class="ptzclose"
      />
      <img
          :src="!videoConf.fullScreen ? fullscreenImage : closefullscreenImage"
          @click="screen"
          :style="{ display: controls.includes('screen') ? 'block' : 'none' }"
          class="screen"
      />
    </div>

    <div class="picker-model" v-if="showPicker">
      <van-picker
          title="请选择子设备"
          :columns="devList"
          :value-key="'DevName'"
          :item-height="'70px'"
          :visible-item-count="8"
          :default-index="channelIndex"
          @change="channelChange"
      />
      <div class="btn-box">
        <div class="cancel-btn" @click="cancel">取消</div>
        <div class="confirm-btn" @click="confirm">确定</div>
      </div>
    </div>
  </div>
</template>

<script>
import fullscreenImage from "@/assets/image/screen.png";
import closefullscreenImage from "@/assets/image/fullscreen.png";
import {
  getMultiMediaAddr,
  openTalk,
  getSubDeviceList,
} from "../api/api";
import {
  moveDeviceApi,
  noticeDeviceUploadPicRequestApi,
  getUserMacsEquipmentsApi,
  controlLightApi2, getOpenLightUserinfoApi2, getOpenLightResultApi2,
} from "../api/custom";
import hdImage from "@/assets/image/hd.png";
import fhdImage from "@/assets/image/fhd.png";
import DeviceFeedControl   from "./DeviceFeedControl.vue";
import Irrigation   from "./Irrigation.vue";

export default {
  name: "HMPalyer",
  components: {
    DeviceFeedControl,
    Irrigation
  },
  data() {
    return {
      serverDomain: "https://testopenlink.smartcloudcon.com",
      appSecret: "G021l7egdug5w4txoz4frfs4y4ywowp5",
      appKey: "G021l7egdug5w4tx",
      utoken: "",
      devList: [
        { DevName: "智能设备12", value: 1 },
        { DevName: "智能设备2", value: 2 },
        { DevName: "智能设备3", value: 3 },
        { DevName: "智能设备4", value: 4 },
        { DevName: "智能设备5", value: 5 },
      ],
      showPicker: false,
      fullscreenImage,
      closefullscreenImage,
      hdImage,
      fhdImage,
      moveDirection: "5",
      controls: ["hd", "cute", "speak", "Mute", "screen"],
      videoConf: {
        definition: "fhd",
        audio: false,
        fullScreen: false,
        showPzt: true,
        player: undefined,
        mediaType: 1,
        mute: false,
      },
      player: null,
      ChannelNum: 0,
      channelIndex: 0,
      channelData: {},
      DevName: "大门",
      CTEI: "",
      mediaData: {},
      ptz: null,
      did: "",
      videoState: 1,
      isIOS: false,
      containerStyle: {},
      isH5: false,
      isPlayer: true,
      isplayBack: false,

      sensorList: [],
      equipmentId: 0,
      page: 1,
      limit: 5,
      isLoading: false,
      noMore: false,
      loadTriggered: false,
      token: "",

      isPolling: false,
      isPollingId: '',
      pollingTimer: null,
      timeoutTimer: null,
      curViewUser: "",
      linkMonitorLicense: null,
      curOrderUser: "",
      pollingCount: 0,

      // 缩放拖动专用变量
      scale: 1,
      viewport: { x: 0, y: 0 },
      touchStart: { scale: 1, x: 0, y: 0, center: { x: 0, y: 0 } },
      isDragging: false,

      //投喂信息
      feeder: {},
      //水闸
      irrigation: {},
    };
  },
  computed: {
    definitionImage() {
      return this[`${this.videoConf.definition}Image`];
    },
  },
  beforeDestroy() {
    console.log("======================----==2");
    this.getPicRequest();
    if(!this.isplayBack) this.player.destroy();
    this.stopPolling();
  },
  async created() {
    let { uid, ctei, did, ChannelNum, DevName, isH5, equipmentId, token,feeder ,irrigation} = this.$route.query;
    if (token) this.token = token;
    if (equipmentId) this.equipmentId = equipmentId;
    try {
      if (feeder && feeder !== '[object Object]') {
        this.feeder = JSON.parse(decodeURIComponent(feeder));
        console.log("feeder:",this.feeder)
      }
      if (irrigation && irrigation !== '[object Object]') {
        this.irrigation = JSON.parse(decodeURIComponent(irrigation));
        console.log("irrigation:",this.irrigation)
      }
    } catch (e) {

    }
    console.log("feeder:",feeder)
    if (uid) this.uid = uid;
    if (ctei) {
      this.CTEI = ctei;
      this.checkDevice();
    }
    if (isH5) {
      this.isH5 = true;
      this.videoState = 2;
    }
    if (did) this.did = did;
    if (ChannelNum) {
      this.ChannelNum = ChannelNum;
      this.getSubDeviceList();
    }
    if (DevName) this.DevName = DevName;
    if (equipmentId > 0) {
      console.log("****普通用户加载列表数据****");
      this.getSensorList();
    }
  },
  mounted() {
    if (!this.isH5) this.getMultiMediaAddress();
    this.ptz = document.getElementsByClassName("ptz")[0];
    this.ptz.addEventListener('touchstart', this.touchstartClick, false);
  },
  methods: {
    handleTouchStart(e) {
      if (this.videoState !== 2) return;
      e.preventDefault();
      const t = e.touches;
      const el = document.getElementById("container");
      const child = el?.children?.[0];
      if (!child) return;

      // 定义坐标变量
      let x1 = t[0].clientX, y1 = t[0].clientY;
      let x2 = t[1]?.clientX, y2 = t[1]?.clientY;

      // 横屏坐标旋转90度适配
      if (this.videoConf.fullScreen) {
        // 旋转公式：x → y，y → 屏幕宽度 - x
        [x1, y1] = [y1, window.innerWidth - x1];
        if (t.length === 2) {
          [x2, y2] = [y2, window.innerWidth - x2];
        }
      }

      if (t.length === 2) {
        this.isDragging = false;
        this.touchStart.distance = Math.hypot(x2 - x1, y2 - y1);
        this.touchStart.center = { x: (x1 + x2) / 2, y: (y1 + y2) / 2 };
        this.touchStart.scale = this.scale;
        this.touchStart.viewport = { ...this.viewport };
      } else if (t.length === 1 && this.scale > 1) {
        this.isDragging = true;
        this.touchStart.x = x1 - this.viewport.x;
        this.touchStart.y = y1 - this.viewport.y;
      }
    },
    handleTouchMove(e) {
      if (this.videoState !== 2) return;
      e.preventDefault();
      const t = e.touches;
      const el = document.getElementById("container");
      const child = el?.children?.[0];
      if (!child) return;

      // 定义坐标变量
      let x1 = t[0].clientX, y1 = t[0].clientY;
      let x2 = t[1]?.clientX, y2 = t[1]?.clientY;

      // 横屏坐标旋转90度适配
      if (this.videoConf.fullScreen) {
        [x1, y1] = [y1, window.innerWidth - x1];
        if (t.length === 2) {
          [x2, y2] = [y2, window.innerWidth - x2];
        }
      }
      if (t.length === 2) {
        const dist = Math.hypot(x2 - x1, y2 - y1);
        const s = this.touchStart.scale * (dist / this.touchStart.distance);
        this.scale = Math.max(1, Math.min(s, 3));

        const cx = (x1 + x2) / 2, cy = (y1 + y2) / 2;
        const dx = cx - this.touchStart.center.x;
        const dy = cy - this.touchStart.center.y;

        this.viewport.x = this.touchStart.viewport.x - dx * (this.scale - 1);
        this.viewport.y = this.touchStart.viewport.y - dy * (this.scale - 1);
        this.limitViewport();
        this.updateTransform(child);
      } else if (t.length === 1 && this.isDragging && this.scale > 1) {
        this.viewport.x = x1 - this.touchStart.x;
        this.viewport.y = y1 - this.touchStart.y;
        this.limitViewport();
        this.updateTransform(child);
      }
    },
    handleTouchEnd() {
      this.isDragging = false;
    },
    limitViewport() {
      const el = document.getElementById("container");
      const w = el.offsetWidth, h = el.offsetHeight;
      const maxX = (this.scale - 1) * w;
      const maxY = (this.scale - 1) * h;
      this.viewport.x = Math.min(0, Math.max(-maxX, this.viewport.x));
      this.viewport.y = Math.min(0, Math.max(-maxY, this.viewport.y));
    },
    updateTransform(child) {
      child.style.transformOrigin = "0 0";
      child.style.transform = `translate(${this.viewport.x}px, ${this.viewport.y}px) scale(${this.scale})`;
    },
    resetZoom() {
      this.scale = 1;
      this.viewport = { x: 0, y: 0 };
      const el = document.getElementById("container");
      const child = el?.children?.[0];
      if (child) {
        child.style.transform = "";
      }
    },

    handleDeviceHistory(item) {
      this.$router.push({ path: '/itemsLog', query: { itemsId: item.itemsId, token: this.token } });
    },
    async handleLightClick(item) {
      if (this.isPolling) {
        this.$showToast('提示','正在查找中，请稍候...','success',3000);
        return;
      }
      this.linkMonitorLicense = item.linkMonitorLicense || this.CTEI;
      if (!this.linkMonitorLicense) {
        this.$showToast('提示','设备license为空，无法执行亮灯操作','warning',3000);
        return;
      }
      try {
        const res = await controlLightApi2({
          license: this.linkMonitorLicense,
          deviceMac: item.deviceMac,
          curOrderUser: this.curOrderUser,
          type:1
        }, this.token);
        if (res.code === 200) {
          this.isPolling = true;
          this.isPollingId = item.itemsId;
          this.pollingCount = 0;
          await this.loadCurLightUser(2, item.itemsId);
          this.startPolling(item.deviceMac);
        } else {
          this.$showToast('失败', res.message || "查找操作失败", 'error', 3000);
        }
      } catch (err) {
        this.isPolling = false;
        this.isPollingId = '';
        this.$showToast('失败', err || "查找操作失败", 'error', 3000);
      }
    },
    startPolling(mac) {
      if (this.pollingTimer) clearInterval(this.pollingTimer);
      if (this.timeoutTimer) clearTimeout(this.timeoutTimer);
      this.doLoadResult(mac);
      this.pollingTimer = setInterval(() => {
        this.doLoadResult(mac);
        this.pollingCount++;
      }, 2000);
      this.timeoutTimer = setTimeout(() => {
        this.stopPolling();
        this.$showToast('请重试',"查找超时",'error',3000);
      }, 30 * 1000);
    },
    stopPolling() {
      this.isPolling = false;
      this.isPollingId = '';
      if (this.pollingTimer) { clearInterval(this.pollingTimer); this.pollingTimer = null; }
      if (this.timeoutTimer) { clearTimeout(this.timeoutTimer); this.timeoutTimer = null; }
      this.pollingCount = 0;
    },
    async loadCurLightUser(i, itemsId) {
      try {
        if (!this.linkMonitorLicense) return;
        const res = await getOpenLightUserinfoApi2({ license: this.linkMonitorLicense }, this.token);
        if (res.data?.isView) {
          this.curViewUser = res.data.nickname;
        } else {
          this.curViewUser = "";
          if (i === 2) {
            this.$showToast('提示','没有人在查看','success',3000);
          }
        }
        if (res.data?.isOwn && !this.isPolling) {
          this.isPolling = true;
          this.isPollingId = itemsId;
          this.startPolling(res.data.mac);
        }
      } catch (err) {
        this.stopPolling();
        console.error("获取亮灯用户失败：", err);
        this.$showToast('失败','获取查找用户失败','error',3000);
      }
    },
    async doLoadResult(mac) {
      if (!this.linkMonitorLicense || !this.isPolling) return;
      try {
        const res = await getOpenLightResultApi2({
          license: this.linkMonitorLicense,
          deviceMac: mac,
        }, this.token);
        if (res.data && res.data.isSucc !== null) {
          this.stopPolling();
          const msg = res.data.isSucc ? '已找到，请留意亮灯！' : '查找失败';
          this.$showToast('已找到', msg, 'success', 3000);
        }
      } catch (err) { console.error(err); }
    },
    getTempClass(status) {
      if (status === 1) return "temp-low";
      if (status === 2) return "temp-high";
      return "";
    },
    handleListScroll() {
      const listDom = this.$refs.sensorListRef;
      if (!listDom || this.isLoading || this.noMore || this.loadTriggered) return;
      const { scrollLeft, scrollWidth, clientWidth } = listDom;
      const isBottom = scrollLeft + clientWidth >= scrollWidth - 20;
      if (isBottom) {
        this.loadTriggered = true;
        this.page++;
        this.getSensorList().finally(() => { this.loadTriggered = false; });
      }
    },
    async getSensorList() {
      if (this.isLoading) return;
      this.isLoading = true;
      try {
        const params = { page: this.page, limit: this.limit, license: this.CTEI, equipmentId: this.equipmentId };
        const res = await getUserMacsEquipmentsApi(params);
        const list = res.data?.list || [];
        const total = res.data?.total || 0;
        if (this.page === 1) {
          this.sensorList = list;
        } else {
          this.sensorList = [...this.sensorList, ...list];
        }
        this.noMore = this.sensorList.length >= total;
      } catch (err) {
        console.error("获取传感器列表失败：", err);
      } finally {
        this.isLoading = false;
      }
    },
    tapPlayer() {
      this.videoState = 1;
      this.isPlayer = false;
      this.getMultiMediaAddress();
    },
    getPicRequest() {
      noticeDeviceUploadPicRequestApi({ gifFlag: 2, license: this.CTEI, picType: 1 });
    },
    checkDevice() {
      const userAgent = navigator.userAgent || '';
      this.isIOS = /iPad|iPhone|iPod/.test(userAgent);
    },
    getMultiMediaAddress() {
      let data = {
        METHOD: "2216",
        SEQID: "10001",
        CTEI: this.CTEI,
        BODY: { Proto: "1", ChannelNum: this.ChannelNum || 0 },
      };
      getMultiMediaAddr(data, this.serverDomain, this.appSecret, this.appKey)
          .then((res) => {
            if (res.data.CODE == 0) {
              this.mediaData = res.data.BODY;
              this.play(res.data.BODY);
            }
          })
          .catch((err) => console.log(err));
    },
    play(videoUrl) {
      if (this.player) this.player.destroy();
      this.resetZoom(); // 切流重置缩放

      let deviceCode = this.did;
      let container = document.getElementById("container");
      let options = {
        container: container,
        delay: 500,
        width: container.offsetWidth,
        height: container.offsetHeight,
        x: 0, y: 300,
        logEnable: true,
        logLevel: "debug",
        decoderMode: "soft-simd",
        useOffScreenCanvasRender: "true",
        useWorkerForMSE: true,
        renderMode: "mse",
        audioEngine: "worklet",
        retryCnt: 0,
        disableAudioForMSE: true
      };
      const that = this;
      this.player = new HMWebPlayer(options);
      this.player.on("state", function ({ state }) {
        if (state == 2) {
          that.videoState = state;
          if (that.videoConf.fullScreen) {
            setTimeout(() => {
              let child = container.children[0];
              child.style.width = "100%";
              child.style.height = "100%";
              child.style.top = "0";
              child.style.left = "0";
            }, 1500);
          }
        }
      });
      this.player.startHMLiveStream(
          "usertoken-a1234567890",
          deviceCode,
          videoUrl.WSUrl,
          videoUrl.ResourceID,
          49,
          videoUrl.EncKey,
          videoUrl.EncLoad,
          0,0,0,0
      );
    },
    channelChange(e, val) { this.channelData = val; },
    cancel() { this.showPicker = false; },
    confirm() {
      this.channelIndex = this.devList.findIndex(item => item.value == this.channelData.value);
      this.ChannelNum = this.channelData.value * 1;
      this.showPicker = false;
      this.getMultiMediaAddress();
    },
    movebutton(arrow) {
      moveDeviceApi({ license: this.CTEI, ptzControl: arrow, step: 360, ptzType: 0 });
    },
    moveEnd() {
      setTimeout(() => {
        moveDeviceApi({
          license: this.CTEI,
          ptzControl: this.moveDirection,
          step: 360,
          ptzType: 3,
        });
      }, 100);
      setTimeout(() => { this.moveDirection = "5"; }, 500);
    },
    moveFill(e) {
      const ptz = this.$refs.ptz;
      let top = e.touches[0].clientY - ptz.getBoundingClientRect().top;
      let left = e.touches[0].clientX - ptz.getBoundingClientRect().left;
      let max_top = ptz.getBoundingClientRect().height;
      let max_left = ptz.getBoundingClientRect().width;

      // 横屏：严格匹配模板里的方向映射
      if (this.videoConf.fullScreen) {
        // 模板里全屏映射：
        // up → moveDirection=3，down→4，right→1，left→2
        if (top < max_top / 2 && top < left && max_left - left > top) {
          // 触摸上 → 对应模板up（moveDirection=3）
          if (this.moveDirection == "3") return;
          this.moveDirection = "3";
          this.movebutton("3", true);
          return;
        }
        if (top > max_top / 2 && top > left && max_left - left < top) {
          // 触摸下 → 对应模板down（moveDirection=4）
          if (this.moveDirection == "4") return;
          this.moveDirection = "4";
          this.movebutton("4", true);
          return;
        }
        if (left < max_left / 2 && top > left && max_left - left > top) {
          // 触摸左 → 对应模板left（moveDirection=2）
          if (this.moveDirection == "2") return;
          this.moveDirection = "2";
          this.movebutton("2", true);
          return;
        }
        if (left > max_left / 2 && top < left && max_left - left < top) {
          // 触摸右 → 对应模板right（moveDirection=1）
          if (this.moveDirection == "1") return;
          this.moveDirection = "1";
          this.movebutton("1", true);
          return;
        }
        return;
      }

      // 竖屏逻辑不变
      if (top < max_top / 2 && top < left && max_left - left > top) {
        if (this.moveDirection == "1") return;
        this.moveDirection = "1";
        this.movebutton("1", true);
        return;
      }
      if (top > max_top / 2 && top > left && max_left - left < top) {
        if (this.moveDirection == "2") return;
        this.moveDirection = "2";
        this.movebutton("2", true);
        return;
      }
      if (left < max_left / 2 && top > left && max_left - left > top) {
        if (this.moveDirection == "3") return;
        this.moveDirection = "3";
        this.movebutton("3", true);
        return;
      }
      if (left > max_left / 2 && top < left && max_left - left < top) {
        if (this.moveDirection == "4") return;
        this.moveDirection = "4";
        this.movebutton("4", true);
        return;
      }
    },

    hd() {
      if (this.videoState != 2) return;
      this.videoConf.definition = this.videoConf.definition === "hd" ? "fhd" : "hd";
      this.videoConf.mediaType = this.videoConf.mediaType == 1 ? 0 : 1;
      this.videoState = 0;
      this.play(this.mediaData);
    },
    cute() {
      if (this.videoState != 2) return;
      this.isplayBack = true;
      if (this.player) this.player.destroy();
      this.$router.push({
        path: "/playBack",
        query: { CTEI: this.CTEI, did: this.did, type: 1 },
      });
    },
    speak() {
      if (this.videoConf.audio) {
        this.player.stopTalk();
        this.videoConf.audio = !this.videoConf.audio;
      } else {
        let data = {
          METHOD: "2310",
          SEQID: "10001",
          BODY: { CTEIs: [this.CTEI], Proto: "1" },
        };
        openTalk(data, this.serverDomain, this.appSecret, this.appKey).then((res) => {
          if (res.data.CODE == 0) {
            let para = res.data.BODY;
            this.player.startTalk(
                para.WSUrl,
                para.SessionID,
                para.ResourceID,
                parseInt(para.EncType),
                para.EncKey,
                para.EncLoad
            );
            this.videoConf.audio = !this.videoConf.audio;
          }
        });
      }
    },
    Mute() {
      if (this.videoState != 2) return;
      if (this.videoConf.mute) {
        this.player.mute();
        this.videoConf.mute = !this.videoConf.mute;
      } else {
        this.player.unMute();
        this.videoConf.mute = !this.videoConf.mute;
      }
    },
    ptzclose() {
      this.videoConf.showPzt = !this.videoConf.showPzt;
    },
    screen() {
      if (this.videoState != 2) return;
      let container = document.querySelector("#container");
      let childNodes = container.children[0];
      let controls = this.controls;
      this.videoConf.fullScreen = !this.videoConf.fullScreen;
      this.videoConf.showPzt = !this.videoConf.fullScreen;

      this.resetZoom(); // 全屏/退出 自动重置缩放
      if (this.videoConf.fullScreen) {
        controls.push("ptzclose");
       // controls = controls.filter((e) => e !== "speak");
        container.style.height = "100vw";
        container.style.width = "100vh";
        container.style.transition = "all 0.3s ease-in-out 0s";
        container.style.transform = "rotate(90deg) translate(0px, -100%)";
        container.style.transformOrigin = "0px 0px";
        container.style.marginTop = "0";
        childNodes.style.width = "100%";
        childNodes.style.height = "100%";
        childNodes.style.top = "0";
        childNodes.style.left = "0";
      } else {
        controls.push("speak");
        controls = controls.filter((e) => e !== "ptzclose");
        container.style.width = "100vw";
        container.style.height = "600px";
        container.style.transition = "all 0.3s ease-in-out 0s";
        container.style.transform = "";
        container.style.marginTop = "300px";
        childNodes.style.width = "100%";
        childNodes.style.height = "600px";
        childNodes.style.top = "auto";
        childNodes.style.left = "0";
      }
      this.controls = controls;
    },
    touchstartClick(e) {
      if (this.videoState != 2) return;
      if (this.videoConf.fullScreen) {
        this.moveFill(e);
        return;
      }
      const ptz = this.$refs.ptz;
      let top = e.touches[0].clientY - ptz.getBoundingClientRect().top;
      let left = e.touches[0].clientX - ptz.getBoundingClientRect().left;
      var max_top = ptz.getBoundingClientRect().height;
      var max_left = ptz.getBoundingClientRect().width;
      if (top < max_top / 2 && top < left && max_left - left > top) {
        if (this.moveDirection == "1") return;
        this.moveDirection = "1";
        this.movebutton("1", false);
        return;
      }
      if (top > max_top / 2 && top > left && max_left - left < top) {
        if (this.moveDirection == "2") return;
        this.moveDirection = "2";
        this.movebutton("2", false);
        return;
      }
      if (left < max_left / 2 && top > left && max_left - left > top) {
        if (this.moveDirection == "3") return;
        this.moveDirection = "3";
        this.movebutton("3", false);
        return;
      }
      if (left > max_left / 2 && top < left && max_left - left < top) {
        if (this.moveDirection == "4") return;
        this.moveDirection = "4";
        this.movebutton("4", false);
        return;
      }
    },
    touchEnd() { this.moveEnd(); },
    checkScene() { this.showPicker = true; },
    getSubDeviceList() {
      let utoken = this.utoken;
      let para = { SEQID: "1", BODY: { DID: this.DID } };
      getSubDeviceList(para).then((res) => console.log(res));
    },
  },
};
</script>

<style scoped lang="less">
.play-1125 {
  width: 150px;
  height: 150px;
  position: absolute;
  top: 580px;
  left: 50%;
  transform: translate(-50%, -50%);
}
.page {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
  background-color: #555555;
}
.huif{
  font-size: 36px;
  color: #fff;
}
.ptz {
  width: 430px !important;
  height: 430px;
  position: absolute;
  bottom: 25%;
  left: 50%;
  transform: translateX(-50%);

  .up,
  .down,
  .right,
  .left {
    width: 430px;
    position: absolute;
    top: 0;
    left: 0;
    pointer-events: none;
    display: none;
  }

  .translucent {
    width: 430px;
    pointer-events: none;
  }
}

.top {
  position: absolute;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;

  p {
    font-size: 36px;
    font-weight: 400;
    color: #ffffff;
    margin-left: 20px;
  }

  img {
    width: 48px;
    height: 48px;
  }
}

.operation {
  position: absolute;
  width: 100%;
  height: 11%;
  bottom: 2%;
  border-top: 1px solid #8a8a8a;
  display: flex;
  justify-content: space-around;
  align-items: center;

  img {
    width: 60px;
    height: 60px;
  }
}

.speak,
.speak_fill {
  width: 96px !important;
  height: 96px !important;
}

.speak_fill {
  position: fixed;
  top: 50%;
  left: 16px;
  transform: translateY(-50%) translateZ(9999px) rotate(90deg);
}

.ptz_fill {
  position: fixed;
  top: 80px;
  left: 16px;
  transform: translateZ(9999px);
}

.operation_fill {
  width: 100%;
  height: 136px;
  position: absolute;
  display: flex;
  bottom: 0;
  left: 0;
  background: linear-gradient(0deg, rgba(255,255,255,0) 0%, rgba(0,0,0,0.5) 100%);
  justify-content: space-around;
  align-items: center;
  flex-direction: row-reverse;
  z-index: 9999;

  img {
    transform: rotate(90deg);
  }
}

.page_fill {
  background-color: #000 !important;
}

#container {
  width: 100vw;
  height: 600px;
  margin-top: 300px;
  background-color: black;
  overflow: hidden; /* 保证画面不跑出去 */
}

.loading {
  position: absolute;
  top: 29%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 9990;
}

.loading > p {
  margin-top: 30px;
  font-size: 24px;
  font-weight: 400;
  color: #ffffff;
}

.loading > img {
  animation: loading 4s linear infinite;
}

@keyframes loading {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.downarrow {
  border-radius: 999px;
  border: 1px solid #fff;
  padding: 8px 12px;
}

.picker-model {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 60%;
  background: white;
  transition: all 0.3s linear;
}

.picker-model /deep/ .van-ellipsis {
  font-size: 40px;
}

.btn-box {
  display: flex;
  justify-content: center;
  margin-top: 30px;

  div {
    font-size: 40px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 220px;
    height: 80px;
  }

  .cancel-btn {
    background: #e2e2e2;
    color: #666;
    margin-right: 40px;
  }

  .confirm-btn {
    background: #30a4ff;
    color: #fff;
  }
}

.sensor-list {
  position: absolute;
  bottom: 14%;
  left: 0;
  width: 100%;
  height: 200px;
  display: flex;
  align-items: center;
  padding: 0 16px;
  padding-right: 40px;
  background: rgba(0, 0, 0, 0.6);
  border-top: 1px solid #444;
  border-bottom: 1px solid #444;
  z-index: 998;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  scroll-behavior: smooth;

  &::-webkit-scrollbar { display: none; }
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.feed-control-wrapper {
  position: absolute;
  bottom: 14%;
  left: 0;
  width: 100%;
  padding: 10px 16px;
  background: rgba(0, 0, 0, 0.6);
  border-top: 1px solid #444;
  border-bottom: 1px solid #444;
  z-index: 998;
  box-sizing: border-box;
}
.sensor-item {
  flex: 0 0 auto;
  width: 180px;
  height: 190px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: rgba(255,255,255,0.1);
  border-radius: 8px;
  margin-right: 12px;
  padding: 8px;
  color: #fff;
  font-size: 24px;
  text-align: center;

  &:last-child { margin-right: 0; }

  .sensor-label { font-size: 22px; margin-bottom: 4px; color: #eee; }
  .sensor-temp { font-size: 22px; font-weight: bold; padding: 2px 12px; border-radius: 4px; margin-bottom: 4px; }
  .sensor-step { font-size: 20px; color: #ddd; }
  .temp-low { background: #1890ff; color: #fff; }
  .temp-high { background: #ff4d4f; color: #fff; }
}

.sensor-status {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 8px;
  width: 100%;
}

.status-item {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.status-btn.online {
  background: #4CAF50;
  color: #fff;
  border: none;
  border-radius: 20px;
  padding: 3px 6px;
  font-size: 26px;
  height: 80px;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  width: 100%;
  justify-content: center;

  &:disabled {
    background: #ccc;
    color: #666;
    cursor: not-allowed;
  }
}

.status-text.offline {
  color: #ff4d4f;
  font-size: 22px;
  text-align: center;
  width: 100%;
  line-height: 48px;
}

.clickable-item {
  cursor: pointer;
  &:hover { background: rgba(255,255,255,0.2); transform: scale(1.02); transition: all 0.2s ease; }
  &:active { transform: scale(0.98); }
}
.load-tips {
  flex: 0 0 auto;
  height: 90px;
  display: flex;
  align-items: center;
  color: #ccc;
  font-size: 24px;
  margin-left: 8px;
  padding: 0 10px;
}
</style>